import type { CreateResumeRoute } from '../types';

import type {
  FieldsRequiredForResumeExport,
  IsFieldPopulatedForResumeExport,
} from './types';

const createResumeOptionalFields: CreateResumeRoute[] = [
  'languages',
  'licences',
];

export const isCreateResumeOptionalFields = (name: CreateResumeRoute) =>
  createResumeOptionalFields.includes(name) === true;

export const isNotCreateResumeOptionalFields = (name: CreateResumeRoute) =>
  createResumeOptionalFields.includes(name) === false;

interface ResumeExportOptions {
  isSummaryRequired: boolean;
}

export const isFieldPopulatedForResumeExport = (
  {
    firstName,
    lastName,
    phoneNumber,
    summary,
    careerHistory,
    education,
    skills,
    languages,
    licences,
  }: FieldsRequiredForResumeExport,
  { isSummaryRequired }: ResumeExportOptions,
): IsFieldPopulatedForResumeExport => ({
  firstName: Boolean(firstName),
  lastName: Boolean(lastName),
  phoneNumber: Boolean(phoneNumber),
  skills: skills.length >= 5,
  careerHistory: careerHistory.length > 0,
  education: education.length > 0,
  summary: isSummaryRequired ? Boolean(summary) : true,
  languages: languages.length > 0,
  licences: licences.length > 0,
});

export const areAllFieldsPopulatedForResumeExport = (
  fieldPopulatedStatus: IsFieldPopulatedForResumeExport,
): boolean => Object.values(fieldPopulatedStatus).every(Boolean);

export const numberOfMissingFields = (
  fieldsPopulated: IsFieldPopulatedForResumeExport,
): number => {
  const fields = Object.values(fieldsPopulated);
  return fields.length - fields.filter(Boolean).length;
};

export const getMissingFieldsFromResumeData = (
  resumeData: FieldsRequiredForResumeExport,
  { isSummaryRequired }: ResumeExportOptions,
): number => {
  const populatedFields = isFieldPopulatedForResumeExport(resumeData, {
    isSummaryRequired,
  });
  const resumeMissingFields = numberOfMissingFields(populatedFields);
  return resumeMissingFields;
};
